<template>
  <main class="bg-main">
    <!-- Grid with no gaps -->
    <div class="grid grid-cols-1 md:grid-cols-5 gap-0 md:mb-8">
      <!-- Person card -->
      <div
        v-for="(person, index) in persons"
        :key="index"
        class="group relative overflow-hidden"
      >
        <!-- Title above the image -->
        <div
          class="text-white text-sm font-bold text-center py-2 mt-2 mb-4 z-10"
        >
          {{ person.title }}
        </div>

        <!-- Image -->
        <div class="w-full h-60 bg-[#6a6a6a] flex items-center justify-center">
          <img
            :src="person.image"
            alt="person image"
            class="max-w-full max-h-full object-contain transition-transform duration-500 transform group-hover:scale-105"
          />
        </div>

        <!-- Hover effect (description with transparent dark background) -->
        <div
          class="absolute inset-0 bg-[#0d142b] bg-opacity-70 flex items-center justify-center text-center text-white opacity-0 group-hover:opacity-100 duration-500 z-20 transform translate-x-full group-hover:translate-x-0 transition-transform"
        >
          <p class="px-4">{{ person.description }}</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      persons: [
        {
          title: "Mentor",
          image: require("../assets/images/brand.jpeg"),
          description:
            "MREM - Join Barka U. Mshelia's exclusive mentorship program to master real estate skills and stay ahead of industry trends. Become part of this powerhouse community of experts today.",
          text: "Mshel Club",
        },
        {
          title: "Investor",
          image: require("../assets/images/gmd png 3 (1).png"),
          description:
            "Arc. Dr. Barka's program connects entrepreneurs with top business leaders, offering funding, partnerships, and mentorship to turn ideas into reality.",
          text: "Mshel Construction",
        },
        {
          title: "Leader",
          image: require("../assets/images/gmd png 2 (1).png"),
          description:
            "With over 200 skilled professionals across 7 subsidairies and more than 1,000 mentees powered through our programs, Barka's leadership goes beyond the ordinary.",
          text: "Mshel Integrated Systems",
        },
        {
          title: "Creator",
          image: require("../assets/images/gmd 3 (1).png"),
          description:
            "Join the conversation and gain experiences to succeed in the business world. Connect with Barka on social media and be part of a supportive community of future leaders.",
          text: "Lisa Suites",
        },
        {
          title: "Speaker",
          image: require("../assets/images/mshel-club.jpeg"),
          description:
            "A platform dedicated to nurturing and empowering leaders in the real estate and business sectors.",
          text: "Mshel Print",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* Hover scale effect for image */
.group-hover\:scale-105 {
  transform: scale(1.05);
}

/* Description slides in smoothly from the right */
.group .translate-x-full {
  transform: translateX(100%);
}
.group-hover\:translate-x-0 {
  transform: translateX(0);
}

/* Smooth transition for the description and opacity */
.group-hover\:opacity-100 {
  opacity: 1;
}
.transition-opacity {
  transition: opacity 0.5s ease;
}
.transition-transform {
  transition: transform 0.5s ease;
}
</style>
